import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import AuthLayout from "./AuthLayout";
import EmailSendIcon from "../../assets/auth/email-send.svg";

const EmailSend = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [resendTimer, setResendTimer] = useState<number>(30); // Initial 30-second timer
  const [canResend, setCanResend] = useState<boolean>(false);
  const location = useLocation();
  const email = location.state?.email;

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setCanResend(true);
    }
  }, [resendTimer]);

  const handleResend = async () => {
    if (!canResend || !email) return;

    setLoading(true);
    setError("");
    setCanResend(false);
    setResendTimer(30); // Reset timer to 30 seconds

    try {
      const functions = getFunctions();
      const sendPasswordReset = httpsCallable(functions, "sendPasswordResetEmail");
      
      await sendPasswordReset({ email });
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to resend email";
      setError(errorMessage);
      setCanResend(true);
      setResendTimer(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-full  px-1">
          <div className="text-center space-y-6  rounded-lg p-3 ">
            <img
              src={EmailSendIcon}
              alt="Email Sent"
              className="mx-auto w-48"
            />
            <h2 className="text-[48px]  nunito-extrabold text-[#0A0A0A]">
              Check your email
            </h2>
            <p className="text-[24px] w-[453px] nunito-regular text-[#696969]  mx-auto">
              We have sent a reset link to your email. Please check your inbox
            </p>

            {error && <div className="text-red-500 text-sm mt-4">{error}</div>}

            <div className="mt-8">
              <span className="flex justify-center items-center gap-2">
                <p className="nunito-regular text-[#696969] text-[20px]">
                  Didn't receive the email?
                </p>
                {canResend ? (
                  <button
                    onClick={handleResend}
                    disabled={loading}
                    className="nunito-semibold text-[#F15D18] text-[20px] hover:underline"
                  >
                    {loading ? "Sending..." : "Resend"}
                  </button>
                ) : (
                  <p className="text-[20px] nunito-regular text-gray-500">
                    Resend in {resendTimer}s
                  </p>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default EmailSend;
